
export default function( settings )
{
    settings.slot.background = 'res/games/game_42/screen.png';
    settings.slot.underScreen = 'res/games/game_42/under_screen.png';
    settings.slot.underScreenPos = {x: 43, y: 137};
    settings.slot.symbol_animation_filename_pattern = 'res/games/game_42/balls/%d/42_%d';
    settings.slot.left_billets_on_filename_pattern = 'res/games/game_42/billets/pl%02d.png';
    settings.slot.right_billets_on_filename_pattern = 'res/games/game_42/billets/pl%02d.png';
    settings.slot.balls = 'res/games/game_42/balls/{symbol}/42_{symbol}_%03d.png';
    settings.slot.lines_pattern = 'res/games/game_42/lines/line_%02d.png';
    settings.slot.frames_template = 'res/games/game_42/frames/c%02d.png';
    settings.slot.systemaTextColor = 0xffe08b;
    settings.slot.terminalTextColor = 0xffe08b;

    settings.table.background = 'res/games/game_42/table/background.png';
    settings.table.combinationNameFormat = 'res/games/game_42/table/comby%02d.png';
    settings.table.coloursCircleNameFormat = 'res/games/game_42/cheque/colours_circul/c%02d.png';
    settings.table.frameNameFormat = 'res/games/game_42/table/rc%02d.png';
    settings.table.scatterPrice = {
        wins:[3],
        position:{x:1124, y:478}
    };

    settings.table.frameYPos = [ 211, 284, 357, 416, 475, 536, 595 ];
    settings.table.priceTable = [
        {
            symbol:0,
            wins:[2,3,4,5],
            position:{x:937, y:214}
        },
        {
            symbol:1,
            wins:[2,3,4,5],
            position:{x:1124, y:214}
        },
        {
            symbol:2,
            wins:[2,3,4,5],
            position:{x:937, y:287}
        },
        {
            symbol:3,
            wins:[2,3,4,5],
            position:{x:1124, y:287}
        },
        {
            symbol:4,
            wins:[3,4,5],
            position:{x:937, y:360}
        },
        {
            symbol:5,
            wins:[3,4,5],
            position:{x:1124, y:360}
        },
        {
            symbol:6,
            wins:[3,4,5],
            position:{x:937, y:419}
        },
        {
            symbol:7,
            wins:[3,4,5],
            position:{x:1124, y:419}
        },
        {
            symbol:8,
            wins:[3,4,5],
            position:{x:937, y:478}
        },
    ];

    settings.slot.left_billets_coords = [
        {x:8, y:390+4},
        {x:8, y:195+4},
        {x:8, y:585+4},
        {x:8, y:130+4},
        {x:8, y:650+4},
        {x:8, y:325+4},
        {x:8, y:455+4},
        {x:8, y:264+4},
        {x:8, y:520+4},
    ];
    settings.slot.right_billets_coords = [
        {x:1138, y:390+4},
        {x:1138, y:195+4},
        {x:1138, y:585+4},
        {x:1138, y:130+4},
        {x:1138, y:650+4},
        {x:1138, y:325+4},
        {x:1138, y:455+4},
        {x:1138, y:520+4},
        {x:1138, y:260+4},
    ];
    settings.slot.lines_position = [
        [ 44, 404 ],
        [ 44, 211 ],
        [ 44, 599 ],
        [ 44, 146 ],
        [ 44, 206 ],
        [ 44, 339 ],
        [ 44, 169 ],
        [ 44, 275 ],
        [ 44, 272 ],
    ];
    settings.help.pages = 35;
    settings.help.pageNameFormat = "res/games/game_42/help/%02d.png";

    settings.texts.imgMain = 'res/games/game_42/game_text.png';
    settings.texts.imgRisk = 'res/games/game_42/risk_text.png';

    settings.risk.background = 'res/games/game_42/risk/risk_screen.png';
    settings.risk.redButton.state.normal = 'res/games/game_42/risk/red_button.png';
    settings.risk.redButton.state.over = 'res/games/game_42/risk/red_button.png';
    settings.risk.redButton.state.pressed = 'res/games/game_42/risk/red_button.png';
    settings.risk.redButton.state.disabled = 'res/games/game_42/risk/red_button.png';
    settings.risk.redButton.position = { x : 140, y : 311+126 };
    settings.risk.blackButton.state.normal = 'res/games/game_42/risk/blue_button.png';
    settings.risk.blackButton.state.over = 'res/games/game_42/risk/blue_button.png';
    settings.risk.blackButton.state.pressed = 'res/games/game_42/risk/blue_button.png';
    settings.risk.blackButton.state.disabled = 'res/games/game_42/risk/blue_button.png';
    settings.risk.blackButton.position = { x : 796, y : 311+126 };
    settings.risk.history.cardOffset = 94;
    settings.risk.currentWinLabel.font = 'risk_result_font_game_42';
    settings.risk.nextWinLabel.font = 'risk_result_font_game_42';
    settings.risk.nextWinLabel.align = 'right';
    settings.risk.currentStepLabel.font = 'risk_step_font_game_42';
    settings.risk.stepsLabel.font = 'risk_step_font_game_42';

    settings.ui.buttons.spin.frames.normal = 'res/games/game_42/ui/rezultat_on.png';
    settings.ui.buttons.spin.frames.disabled = 'res/games/game_42/ui/rezultat_of.png';
    settings.ui.buttons.collect.frames.normal = 'res/games/game_42/ui/rezultat_on.png';
    settings.ui.buttons.collect.frames.disabled = 'res/games/game_42/ui/rezultat_of.png';
    settings.ui.buttons.finish.frames.normal = 'res/games/game_42/ui/exit_pari_of.png';
    settings.ui.buttons.finish.frames.disabled = 'res/games/game_42/ui/exit_pari_of.png';
    settings.ui.buttons.end_pari.frames.normal = 'res/games/game_42/ui/exit_pari_of.png';
    settings.ui.buttons.end_pari.frames.disabled = 'res/games/game_42/ui/exit_pari_of.png';
    settings.ui.buttons.gamble.frames.normal = 'res/games/game_42/ui/auto_on.png';
    settings.ui.buttons.gamble.frames.disabled = 'res/games/game_42/ui/auto_of.png';
    settings.ui.buttons.risk_red.frames.normal = 'res/games/game_42/ui/red_on.png';
    settings.ui.buttons.risk_red.frames.disabled = 'res/games/game_42/ui/red_of.png';
    settings.ui.buttons.risk_black.frames.normal = 'res/games/game_42/ui/black_on.png';
    settings.ui.buttons.risk_black.frames.disabled = 'res/games/game_42/ui/black_of.png';
    settings.ui.buttons.next.frames.normal = 'res/games/game_42/ui/next_on.png';
    settings.ui.buttons.next.frames.disabled = 'res/games/game_42/ui/next_of.png';
    settings.ui.buttons.back.frames.normal = 'res/games/game_42/ui/prev_on.png';
    settings.ui.buttons.back.frames.disabled = 'res/games/game_42/ui/prev_of.png';
    settings.ui.buttons.exit.frames.normal =  'res/games/game_42/ui/help_back_off.png';
    settings.ui.buttons.exit.frames.disabled =  'res/games/game_42/ui/help_back_on.png';


    settings.ui.buttons.info.position =  {x : 1053, y : 7 };
    settings.ui.buttons.menu.position =  {x : 1192, y : 761 };
    settings.ui.buttons.linebet.position =  {x : 1192, y : 825 };
    settings.ui.buttons.autoplay.position =  {x : 1322, y : 763 };
    settings.ui.buttons.autoplayoff.position =  {x : 1322, y : 763 };
    settings.ui.buttons.start.position =  {x : 1322, y : 763 };
    settings.ui.buttons.gamble.position =  {x : 1322, y : 763 };
    settings.ui.buttons.spin.position =  {x : 1451, y : 763 };
    settings.ui.buttons.collect.position =  {x : 1451, y : 763 };
    settings.ui.buttons.next.position =  {x : 794, y : 814 };
    settings.ui.buttons.back.position =  {x : 662, y : 814 };
    settings.ui.buttons.exit.position =  {x : 24, y : 814 };


    settings.ui.buttons.autoplay.frames.normal = 'res/games/game_42/ui/auto_on.png';
    settings.ui.buttons.autoplay.frames.disabled = 'res/games/game_42/ui/auto_of.png';
    settings.ui.buttons.autoplayoff.frames.normal = 'res/games/game_42/ui/auto_on.png';
    settings.ui.buttons.autoplayoff.frames.disabled = 'res/games/game_42/ui/auto_of.png';
    settings.ui.buttons.menu.frames.normal = 'res/games/game_42/ui/menu_on.png';
    settings.ui.buttons.menu.frames.disabled = 'res/games/game_42/ui/menu_of.png';
    settings.ui.buttons.linebet.frames.normal = 'res/games/game_42/ui/size_step_on.png';
    settings.ui.buttons.linebet.frames.disabled = 'res/games/game_42/ui/size_step_of.png';
    settings.ui.buttons.visual_mode.frames.normal = 'res/games/game_42/ui/visual_mode_on.png';
    settings.ui.buttons.visual_mode.frames.disabled = 'res/games/game_42/ui/visual_mode_of.png';
    settings.ui.buttons.visual_mode.frames.normal = 'res/games/game_42/ui/visual_mode_on.png';
    settings.ui.buttons.visual_mode.frames.disabled = 'res/games/game_42/ui/visual_mode_of.png';
    settings.ui.buttons.info.frames.normal = 'res/games/game_42/ui/info_on.png';
    settings.ui.buttons.info.frames.disabled = 'res/games/game_42/ui/info_of.png';


    settings.smallTicket.miniballsNameFormat = 'res/games/game_42/small_ticket/miniballs/mb%02d.png';

    return {
        //settings можно смело модифицировать - он копируется для каждой игры из шаблона:
        settings,

        //name для удобства чтения логов на сервере:
        name : 'game_42',
        //идентификатор математики на сервере:
        id : 585,

        reactive,

        graphics : [

            //small ticket:
            'res/games/game_42/small_ticket/balls_screen.png',
            'res/games/game_42/small_ticket/risk_screen00.png',
            'res/games/game_42/small_ticket/risk_screen01.png',
            'res/games/game_42/small_ticket/sat_01.png',
            'res/games/game_42/small_ticket/sat_02.png',
            'res/games/game_42/small_ticket/sat_03.png',
            'res/games/game_42/small_ticket/sat_04.png',
            'res/games/game_42/small_ticket/sat_05.png',
            'res/games/small_ticket/small_ticket_digits.xml',
            'res/games/game_42/small_ticket/miniballs/mb00.png',
            'res/games/game_42/small_ticket/miniballs/mb01.png',
            'res/games/game_42/small_ticket/miniballs/mb02.png',
            'res/games/game_42/small_ticket/miniballs/mb03.png',
            'res/games/game_42/small_ticket/miniballs/mb04.png',
            'res/games/game_42/small_ticket/miniballs/mb05.png',
            'res/games/game_42/small_ticket/miniballs/mb06.png',
            'res/games/game_42/small_ticket/miniballs/mb07.png',
            'res/games/game_42/small_ticket/miniballs/mb08.png',

            //help:
            'res/games/game_42/help/00.png',
            'res/games/game_42/help/01.png',
            'res/games/game_42/help/02.png',
            'res/games/game_42/help/03.png',
            'res/games/game_42/help/04.png',
            'res/games/game_42/help/05.png',
            'res/games/game_42/help/06.png',
            'res/games/game_42/help/07.png',
            'res/games/game_42/help/08.png',
            'res/games/game_42/help/09.png',
            'res/games/game_42/help/10.png',
            'res/games/game_42/help/11.png',
            'res/games/game_42/help/12.png',
            'res/games/game_42/help/13.png',
            'res/games/game_42/help/14.png',
            'res/games/game_42/help/15.png',
            'res/games/game_42/help/16.png',
            'res/games/game_42/help/17.png',
            'res/games/game_42/help/18.png',
            'res/games/game_42/help/19.png',
            'res/games/game_42/help/20.png',
            'res/games/game_42/help/21.png',
            'res/games/game_42/help/22.png',
            'res/games/game_42/help/23.png',
            'res/games/game_42/help/24.png',
            'res/games/game_42/help/25.png',
            'res/games/game_42/help/26.png',
            'res/games/game_42/help/27.png',
            'res/games/game_42/help/28.png',
            'res/games/game_42/help/29.png',
            'res/games/game_42/help/30.png',
            'res/games/game_42/help/31.png',
            'res/games/game_42/help/32.png',
            'res/games/game_42/help/33.png',
            'res/games/game_42/help/34.png',

            //risk:
            'res/games/risk/masti/bubi.png',
            'res/games/risk/masti/piki.png',
            'res/games/risk/black_ball.png',
            'res/games/game_42/risk/blue_button.png',
            'res/games/risk/card_black.png',
            'res/games/risk/card_red.png',
            'res/games/risk/red_ball.png',
            'res/games/game_42/risk/red_button.png',
            'res/games/game_42/risk/risk_screen.png',
            'res/games/risk/rubaska_big/rbb.png',
            'res/games/risk/rubaska_big/rbr.png',
            'res/games/game_42/risk/risk_result_font_game_42.xml',
            'res/games/game_42/risk/risk_step_font_game_42.xml',

            //table:
            'res/games/game_42/table/background.png',
            'res/games/table/coeff_tab_digits.xml',
            'res/games/game_42/table/comby00.png',
            'res/games/game_42/table/comby01.png',
            'res/games/game_42/table/comby02.png',
            'res/games/game_42/table/comby03.png',
            'res/games/game_42/table/comby04.png',
            //cheque:
            'res/games/cheque/chek.png',
            'res/games/cheque/digits_ishod.xml',
            'res/games/game_42/cheque/colours_circul/c00.png',
            'res/games/game_42/cheque/colours_circul/c01.png',
            'res/games/game_42/cheque/colours_circul/c02.png',
            'res/games/game_42/cheque/colours_circul/c03.png',
            'res/games/game_42/cheque/colours_circul/c04.png',
            'res/games/game_42/cheque/colours_circul/c05.png',
            'res/games/game_42/cheque/colours_circul/c06.png',
            'res/games/game_42/cheque/colours_circul/c07.png',
            'res/games/game_42/cheque/colours_circul/c08.png',
            'res/games/game_42/table/rc00.png',
            'res/games/game_42/table/rc01.png',
            'res/games/game_42/table/rc02.png',
            'res/games/game_42/table/rc03.png',
            'res/games/game_42/table/rc04.png',
            'res/games/game_42/table/rc05.png',
            'res/games/game_42/table/rc06.png',
            'res/games/game_42/table/rc07.png',
            'res/games/game_42/table/rc08.png',

            //ui:
            'res/games/ui/yello_dig.xml',
            'res/games/game_42/ui/auto_of.png',
            'res/games/game_42/ui/auto_on.png',
            'res/games/game_42/ui/black_of.png',
            'res/games/game_42/ui/black_on.png',
            'res/games/game_42/ui/exit_pari_of.png',
            'res/games/game_42/ui/exit_pari_on.png',
            'res/games/game_42/ui/menu_of.png',
            'res/games/game_42/ui/menu_on.png',
            'res/games/game_42/ui/red_of.png',
            'res/games/game_42/ui/red_on.png',
            'res/games/game_42/ui/rezultat_of.png',
            'res/games/game_42/ui/rezultat_on.png',
            'res/games/game_42/ui/size_step_on.png',
            'res/games/game_42/ui/size_step_of.png',
            'res/games/game_42/ui/visual_mode_of.png',
            'res/games/game_42/ui/visual_mode_on.png',
            'res/games/game_42/ui/info_of.png',
            'res/games/game_42/ui/info_on.png',
            'res/games/game_42/ui/next_of.png',
            'res/games/game_42/ui/next_on.png',
            'res/games/game_42/ui/prev_of.png',
            'res/games/game_42/ui/prev_on.png',
            'res/games/game_42/ui/help_back_off.png',
            'res/games/game_42/ui/help_back_on.png',

            'res/games/game_42/screen.png',
            'res/games/game_42/under_screen.png',
            'res/games/game_42/game_text.png',
            'res/games/game_42/risk_text.png',

            'res/games/game_42/billets/pl00.png',
            'res/games/game_42/billets/pl01.png',
            'res/games/game_42/billets/pl02.png',
            'res/games/game_42/billets/pl03.png',
            'res/games/game_42/billets/pl04.png',
            'res/games/game_42/billets/pl05.png',
            'res/games/game_42/billets/pl06.png',
            'res/games/game_42/billets/pl07.png',
            'res/games/game_42/billets/pl08.png',

            'res/games/game_42/frames/c00.png',
            'res/games/game_42/frames/c01.png',
            'res/games/game_42/frames/c02.png',
            'res/games/game_42/frames/c03.png',
            'res/games/game_42/frames/c04.png',
            'res/games/game_42/frames/c05.png',
            'res/games/game_42/frames/c06.png',
            'res/games/game_42/frames/c07.png',
            'res/games/game_42/frames/c08.png',

            'res/games/game_42/lines/line_00.png',
            'res/games/game_42/lines/line_01.png',
            'res/games/game_42/lines/line_02.png',
            'res/games/game_42/lines/line_03.png',
            'res/games/game_42/lines/line_04.png',
            'res/games/game_42/lines/line_05.png',
            'res/games/game_42/lines/line_06.png',
            'res/games/game_42/lines/line_07.png',
            'res/games/game_42/lines/line_08.png',

            'res/games/mini_balls/for_balls.png',
            'res/games/a1_a15.png',
            //потом займёмся упаковкой и прочим ;) (думаю даже вообще удастся как-то свести все эти игры под одну с маленькими отличиями) ...
            'res/games/mini_balls/0_00.png',
            'res/games/mini_balls/0_01.png',
            'res/games/mini_balls/0_02.png',
            'res/games/mini_balls/1_00.png',
            'res/games/mini_balls/1_01.png',
            'res/games/mini_balls/1_02.png',
            'res/games/mini_balls/2_00.png',
            'res/games/mini_balls/2_01.png',
            'res/games/mini_balls/2_02.png',
            'res/games/mini_balls/3_00.png',
            'res/games/mini_balls/3_01.png',
            'res/games/mini_balls/3_02.png',
            'res/games/mini_balls/4_00.png',
            'res/games/mini_balls/4_01.png',
            'res/games/mini_balls/4_02.png',
            'res/games/mini_balls/5_00.png',
            'res/games/mini_balls/5_01.png',
            'res/games/mini_balls/5_02.png',
            'res/games/mini_balls/6_00.png',
            'res/games/mini_balls/6_01.png',
            'res/games/mini_balls/6_02.png',
            'res/games/mini_balls/7_00.png',
            'res/games/mini_balls/7_01.png',
            'res/games/mini_balls/7_02.png',
            'res/games/mini_balls/8_00.png',
            'res/games/mini_balls/8_01.png',
            'res/games/mini_balls/8_02.png',
            'res/games/mini_balls/9_00.png',
            'res/games/mini_balls/9_01.png',
            'res/games/mini_balls/9_02.png',
            'res/games/mini_balls/10_00.png',
            'res/games/mini_balls/10_01.png',
            'res/games/mini_balls/10_02.png',
            'res/games/mini_balls/11_00.png',
            'res/games/mini_balls/11_01.png',
            'res/games/mini_balls/11_02.png',
            'res/games/mini_balls/12_00.png',
            'res/games/mini_balls/12_01.png',
            'res/games/mini_balls/12_02.png',
            'res/games/mini_balls/black_01.png',
            'res/games/mini_balls/red_01.png',

            'res/games/game_42/balls/0/42_0_000.png',
            'res/games/game_42/balls/0/42_0_001.png',
            'res/games/game_42/balls/0/42_0_002.png',
            'res/games/game_42/balls/0/42_0_003.png',
            'res/games/game_42/balls/0/42_0_004.png',
            'res/games/game_42/balls/0/42_0_005.png',
            'res/games/game_42/balls/0/42_0_006.png',
            'res/games/game_42/balls/0/42_0_007.png',
            'res/games/game_42/balls/0/42_0_008.png',
            'res/games/game_42/balls/1/42_1_000.png',
            'res/games/game_42/balls/1/42_1_001.png',
            'res/games/game_42/balls/1/42_1_002.png',
            'res/games/game_42/balls/1/42_1_003.png',
            'res/games/game_42/balls/1/42_1_004.png',
            'res/games/game_42/balls/1/42_1_005.png',
            'res/games/game_42/balls/1/42_1_006.png',
            'res/games/game_42/balls/1/42_1_007.png',
            'res/games/game_42/balls/1/42_1_008.png',
            'res/games/game_42/balls/2/42_2_000.png',
            'res/games/game_42/balls/2/42_2_001.png',
            'res/games/game_42/balls/2/42_2_002.png',
            'res/games/game_42/balls/2/42_2_003.png',
            'res/games/game_42/balls/2/42_2_004.png',
            'res/games/game_42/balls/2/42_2_005.png',
            'res/games/game_42/balls/2/42_2_006.png',
            'res/games/game_42/balls/2/42_2_007.png',
            'res/games/game_42/balls/2/42_2_008.png',
            'res/games/game_42/balls/3/42_3_000.png',
            'res/games/game_42/balls/3/42_3_001.png',
            'res/games/game_42/balls/3/42_3_002.png',
            'res/games/game_42/balls/3/42_3_003.png',
            'res/games/game_42/balls/3/42_3_004.png',
            'res/games/game_42/balls/3/42_3_005.png',
            'res/games/game_42/balls/3/42_3_006.png',
            'res/games/game_42/balls/3/42_3_007.png',
            'res/games/game_42/balls/3/42_3_008.png',
            'res/games/game_42/balls/4/42_4_000.png',
            'res/games/game_42/balls/4/42_4_001.png',
            'res/games/game_42/balls/4/42_4_002.png',
            'res/games/game_42/balls/4/42_4_003.png',
            'res/games/game_42/balls/4/42_4_004.png',
            'res/games/game_42/balls/4/42_4_005.png',
            'res/games/game_42/balls/4/42_4_006.png',
            'res/games/game_42/balls/4/42_4_007.png',
            'res/games/game_42/balls/4/42_4_008.png',
            'res/games/game_42/balls/5/42_5_000.png',
            'res/games/game_42/balls/5/42_5_001.png',
            'res/games/game_42/balls/5/42_5_002.png',
            'res/games/game_42/balls/5/42_5_003.png',
            'res/games/game_42/balls/5/42_5_004.png',
            'res/games/game_42/balls/5/42_5_005.png',
            'res/games/game_42/balls/5/42_5_006.png',
            'res/games/game_42/balls/5/42_5_007.png',
            'res/games/game_42/balls/5/42_5_008.png',
            'res/games/game_42/balls/6/42_6_000.png',
            'res/games/game_42/balls/6/42_6_001.png',
            'res/games/game_42/balls/6/42_6_002.png',
            'res/games/game_42/balls/6/42_6_003.png',
            'res/games/game_42/balls/6/42_6_004.png',
            'res/games/game_42/balls/6/42_6_005.png',
            'res/games/game_42/balls/6/42_6_006.png',
            'res/games/game_42/balls/6/42_6_007.png',
            'res/games/game_42/balls/6/42_6_008.png',
            'res/games/game_42/balls/7/42_7_000.png',
            'res/games/game_42/balls/7/42_7_001.png',
            'res/games/game_42/balls/7/42_7_002.png',
            'res/games/game_42/balls/7/42_7_003.png',
            'res/games/game_42/balls/7/42_7_004.png',
            'res/games/game_42/balls/7/42_7_005.png',
            'res/games/game_42/balls/7/42_7_006.png',
            'res/games/game_42/balls/7/42_7_007.png',
            'res/games/game_42/balls/7/42_7_008.png',
            'res/games/game_42/balls/8/42_8_000.png',
            'res/games/game_42/balls/8/42_8_001.png',
            'res/games/game_42/balls/8/42_8_002.png',
            'res/games/game_42/balls/8/42_8_003.png',
            'res/games/game_42/balls/8/42_8_004.png',
            'res/games/game_42/balls/8/42_8_005.png',
            'res/games/game_42/balls/8/42_8_006.png',
            'res/games/game_42/balls/8/42_8_007.png',
            'res/games/game_42/balls/8/42_8_008.png',
            'res/games/game_42/balls/9/42_9_000.png',
            'res/games/game_42/balls/9/42_9_001.png',
            'res/games/game_42/balls/9/42_9_002.png',
            'res/games/game_42/balls/9/42_9_003.png',
            'res/games/game_42/balls/9/42_9_004.png',
            'res/games/game_42/balls/9/42_9_005.png',
            'res/games/game_42/balls/9/42_9_006.png',
            'res/games/game_42/balls/9/42_9_007.png',
            'res/games/game_42/balls/9/42_9_008.png',
            'res/games/game_42/balls/10/42_10_000.png',
            'res/games/game_42/balls/10/42_10_001.png',
            'res/games/game_42/balls/10/42_10_002.png',
            'res/games/game_42/balls/10/42_10_003.png',
            'res/games/game_42/balls/10/42_10_004.png',
            'res/games/game_42/balls/10/42_10_005.png',
            'res/games/game_42/balls/10/42_10_006.png',
            'res/games/game_42/balls/10/42_10_007.png',
            'res/games/game_42/balls/10/42_10_008.png',

            
            //common:
            'res/games/preloader.png',
        ],
        sounds : [],
    }
}

function reactive( { space, container } ) {
    //тут можно изменять space типа space.s( 'stream' ).alter() или добавлять что-то в container ...
}



// WEBPACK FOOTER //
// ./src/games/game_42.es6